module.exports = __webpack_public_path__ + "img/bcc.37db54e6.svg";